import { Loader } from './Loader'

interface SecondaryButtonProps
  extends React.ComponentPropsWithoutRef<'button'> {
  width?: 'full' | 'auto'
  isSubmitting?: boolean
}

export const SecondaryButton = ({
  children,
  width = 'full',
  isSubmitting = false,
  ...buttonProps
}: SecondaryButtonProps): JSX.Element => (
  <button
    className={`relative mt-1 self-start w-full py-4 px-16 ${
      width === 'full' ? 'md:w-full' : 'md:w-auto'
    } rounded-full text-brand-purple font-normal border-2 border-brand-purple${
      isSubmitting ? ' opacity-50' : ''
    } hover-hover:hover:bg-brand-light-purple hover-hover:hover:bg-opacity-30 active:bg-brand-light-purple active:bg-opacity-30 disabled:bg-opacity-0 focus:outline-none focus:ring-2`}
    disabled={isSubmitting}
    {...buttonProps}
  >
    {isSubmitting && <Loader color='text-brand-purple' />}
    {children}
  </button>
)
